import { Field, Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import FormControl from '../components/form/FormControl';
import SubmitButton from '../components/SubmitButton';
import usePost from '../customHooks/usePost';
import { toast } from 'react-toastify';
import OneImageUpload from '../components/OneImageUpload';
import swal from 'sweetalert';
import { Link, useNavigate } from 'react-router-dom';
import back from '../dist/webImages/back.svg';

const PopupBannerCreate = () => {
  const navigate = useNavigate();
  const [imageLoader, setImageLoader] = useState(false);
  const [datas, setDatas] = useState({
    attachment: '',
  });
  const [res, apiMethod] = usePost();

  const initialValues = {
    title: '',
    redirect_link: '',
    from_date: '',
    to_date: '',
    status: ['1'],
  };

  const requireFeild = ['title', 'from_date', 'to_date'];

  const handleSubmit = async (values) => {
    if (imageLoader) {
      swal({
        title: 'Wait a Few Second',
        icon: 'error',
        dangerMode: true,
      });
      return;
    }

    const requireFeildSwal = {
      title: 'Title',
      from_date: 'From Date',
      to_date: 'To Date',
    };
    const checkerRequried = [];
    for (const item in values) {
      if (requireFeild.includes(item) && !values[item]) {
        checkerRequried.push(requireFeildSwal[item]);
      }
    }

    if (checkerRequried.length > 0) {
      swal({
        title: 'Required Fields are empty! Please fill and try again',
        text: checkerRequried.join(','),
        icon: 'error',
        dangerMode: true,
      });
      return;
    }

    const formdata = new FormData();
    formdata.append('title', values['title'] ?? '');
    formdata.append('redirect_link', values['redirect_link'] ?? '');
    formdata.append('from_date', values['from_date'] ?? '');
    formdata.append('to_date', values['to_date'] ?? '');
    formdata.append('attachment', datas?.attachment_value ?? '');
    const isActive = Array.isArray(values.status) ? values.status.length > 0 : Boolean(values.status);
    formdata.append('status', isActive ? 1 : 0);
    apiMethod('popupBanner', formdata);
  };

  useEffect(() => {
    if (res.data) {
      const { status, message } = res?.data;
      if (status === false) {
        toast.error(message);
      } else {
        navigate('/popup_banner');
        toast.success(message);
      }
    }
  }, [res.data]);

  return (
    <div className='newscreate pr-10 max-lg:pr-6'>
      <Link to={'/popup_banner'} className="back flex items-center mb-6 gap-2">
        <img src={back} className='w-[2rem]' alt="" />
        <span className='text-[1.4rem] font-MluvkaBold'>Create Popup Banner</span>
      </Link>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        <Form>
          <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-8'>
            <FormControl name="title" label={"Title"} placeholder="Enter Title" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
            <FormControl name="redirect_link" label={"Redirect Link"} placeholder="Enter Redirect Link" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
            <div className="grid grid-cols-2 gap-4 max-lg:grid-cols-1">
              <FormControl name="from_date" label={"From Date"} type="date" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
              <FormControl name="to_date" label={"To Date"} type="date" className="outline-none w-full h-[3rem] px-5 rounded-xl" control="input2" />
            </div>
            <div className='mt-4'>
              <div>
                <label className="mb-1 mt-3 block text-[#7D8CA7] text-[.8rem]">Attachment</label>
                <OneImageUpload
                  changeImage={setImageLoader}
                  MainImage={datas?.attachment}
                  Update={setDatas}
                  sec_value={"attachment_value"}
                  sec_image={"attachment"}
                  folder_name={"popup-banner"}
                  page_type={"popupBanner"}
                />
              </div>
              <div className="overflow-hidden relative pt-7 px-4">
                <label className="inline-flex items-center cursor-pointer">
                  <Field value="1" type="checkbox" name="status" className="sr-only peer" />
                  <div className="relative bg-[#1c1c1c] w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer bg-gray-200 peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#401a89]"></div>
                  <span className="ms-3 text-sm font-medium text-gray-900">Popup Banner Status</span>
                </label>
              </div>
            </div>
          </div>
          <SubmitButton
            props={{
              class: "btn bg-secondary text-white uppercase py-3 px-10 rounded-full w-fit block submit hover:bg-primary transition-all duration-300",
              text: "Save",
            }}
            buttonLoading={res.isLoading}
          />
          <br />
        </Form>
      </Formik>
    </div>
  );
};

export default PopupBannerCreate;


